<template>
  <div class="mainDiv">
    <div class="backBtn" @click="goBack">
      <inline-svg
        class="backs-svg"
        :src="require('../../assets/svg/back.svg').default"
      ></inline-svg>
    </div>
    <p>{{ $t("registration.privacy.title") }}</p>
    <span
      style="width: 100%; font-size: 14px; text-align: var(--src-position);"
    >
      <p>
        {{ $t("registration.privacy.text1") }}
      </p>
      <p>
        {{ $t("registration.privacy.text2") }}
      </p>
      <p>
        {{ $t("registration.privacy.text3") }}
      </p>
      <p>
        {{ $t("registration.privacy.text4") }}
      </p>
      <p>{{ $t("registration.privacy.text5") }}</p>
      <p>
        {{ $t("registration.privacy.text6") }}
      </p>
      <p>{{ $t("registration.privacy.text7") }}</p>
      <p>
        {{ $t("registration.privacy.text8") }}
      </p>
      <p>
        {{ $t("registration.privacy.text9") }}
      </p>
      <p>{{ $t("registration.privacy.text10") }}</p>
      <p v-html="$t('registration.privacy.text11')"></p>
      <p>
        {{ $t("registration.privacy.text12") }}
      </p>
    </span>
    <div class="backBtn" @click="goBack">
      <inline-svg
        class="backs-svg"
        :src="require('../../assets/svg/back.svg').default"
      ></inline-svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "privacy",
  methods: {
    goBack() {
      this.$router.push("/registration");
    }
  }
};
</script>
<style scoped>
.backBtn {
  width: 40px;
  margin: auto;
}
.mainDiv {
  text-align: center;
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// Privacy.vue?b1619504